import type { ChatMessage, ImagePart, MessageContent } from '../types/chat';

export function messageText(content: MessageContent): string {
  if (typeof content === 'string') return content;
  return content
    .filter((part): part is { type: 'text'; text: string } => part.type === 'text')
    .map((part) => part.text)
    .join('\n');
}

export function messageImage(content: MessageContent): ImagePart['image_url'] | null {
  if (!Array.isArray(content)) return null;
  return content.find((part): part is ImagePart => part.type === 'image_url')?.image_url ?? null;
}

export function conversationTitle(message: ChatMessage): string {
  const text = messageText(message.content).replace(/\s+/g, ' ').trim();
  if (text) return text.length > 34 ? `${text.slice(0, 34).trim()}…` : text;
  return messageImage(message.content)?.name || 'Analisis gambar';
}

export function apiContent(content: MessageContent): MessageContent {
  if (typeof content === 'string') return content;
  return content.map((part) => {
    if (part.type === 'text') return part;
    return { type: 'image_url' as const, image_url: { url: part.image_url.url } };
  });
}
